import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { NavLink } from "react-router-dom";
var Logo = function () {
    return (_jsxs(_Fragment, { children: [_jsx(NavLink, { className: "c-sidebar-brand-full", to: "/", children: _jsx("h4", { className: "text-light c-sidebar-brand-full", children: _jsx("img", { alt: "LTIAAS Logo", width: "100", src: "/white.png" }) }) }), _jsx(NavLink, { className: "c-sidebar-brand-minimized", to: "/", children: _jsx("h4", { className: "c-sidebar-brand-minimized", children: _jsx("img", { alt: "LTIAAS Logo", width: "40", src: "/white.png" }) }) })] }));
};
export default Logo;
